<template>
  <table>
    <tr>
      <!-- <td style="width:15%;min-width:100px;" > -->
        <!-- <select class="normalInput normalSelect" ref="site" id="select" style="background-color: white;">
          <option value = "" selected>{{ $t('menu.selectSite') }}</option>
          <option value = "CAROUSELL">CAROUSELL</option>
          <option value = "VINTED">VINTED</option>
          <option value = "SHOPEE">SHOPEE</option>
        </select> -->
      <!-- </td> -->
      <td style="width:100%;" >
        <input class="normalInput normalSelect" v-on:keyup.enter="calcPrice(3)" ref="url" id="url" :placeholder="$t('sentence.itemUrlBuy')" type="url">
      </td>
      <td style="min-width:100px;" >
        <Button v-on:click="calcPrice(3)" style="width:100%;" :label="$t('menu.search')" raised size="small" />
      </td>
    </tr>
  </table>
  <br>
  <div class="container">
    <div class="no-result">{{ $t('sentence.wrongInfo79') }}</div>
    <table class="table" ref="table" style="display:none;">
      <tr>
        <td ><img ref="result1" style="height:150px;" class="padding-left" alt="geek9.kr"></td>
        <td class="td">
          <div class="padding" ref="result2"/> 
          <div class="padding" ref="result3"/> 
          <div class="padding" ref="result4"/> 
          <div class="padding" ref="result5"/> 
          <div class="padding" ref="result6"/>
          <div class="padding"><a target="_blank" ref="link">{{ $t('menu.url') }}</a></div>
          <div>
            <Button @click="order()" :label="$t('menu.order') " raised size="small" />
          </div>
        </td>
      </tr>
    </table>
  </div>
  <Modal v-model='isShow' :close='closeModal' style="z-index: 99999999999;">
    <div class="modal">
      <div style="margin-top:20px;margin-bottom:20px;">
        <p>{{ $t('sentence.item15') }}</p>
        <p>{{ $t('sentence.item16') }}</p>
        <p>{{ $t('sentence.item17') }}</p>
        <p>{{ $t('sentence.item18') }}</p>
      </div>
      <table>
        <tr>
          <td style="min-width:100px;">
            <select class="normalInput normalSelect" ref="modalCountry" style="background-color: white;">
              <option value = "" selected>{{ $t('menu.selectCountry') }}</option>
              <option value = "hk">{{ $t('country.HK') }}</option>
              <option value = "sg">{{ $t('country.SG') }}</option>
            </select>
          </td>
          <td style="width:100%;">
            <input class="normalInput normalSelect" v-on:keyup.enter="calcPrice(4)" ref="modalSellPrice" :placeholder="$t('menu.fPrice')" type="number" style="width:100%;">
          </td>
          <td style="min-width:50px;" >
            <Button  v-on:click="calcPrice(4)" :label="$t('menu.search')" raised size="small" />
          </td>
          <td style="min-width:50px;">
            <Button @click="closeModal()" :label="$t('menu.close')" raised size="small" />
          </td>
        </tr>
      </table>
    </div>
  </Modal>
</template>

<script>

import router from '../../router'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

export default {
  setup() {
    const { t } = useI18n()
    const isShow = ref(false)
    async function showModal () {
      isShow.value = true
    }
    function closeModal () {
      isShow.value = false
    }
    return {
      closeModal, showModal, isShow, t
    }
  },
  data() { 
    return {
       url:'',
       name:'',
       sellPrice:'',
       country:'',
       imgUrl:'',
       wonPrice:''
    }; 
  },
  methods: {
    async order() {
      router.push({ name: "order", params: { 
        url: this.url, 
        name: this.api.emojiRemover(this.name), 
        sellPrice:this.sellPrice, 
        country:this.country, 
        imgUrl:this.imgUrl, 
        wonPrice:this.wonPrice } })
    },
    async calcPrice(type) {
      if(type === 3) {
        let url = this.$refs.url.value;
        if(url == '' ) alert(`${this.t('sentence.emptyField')}`)
        // } else if(url.indexOf('vinted') === -1 && url.indexOf('carousell') === -1 && url.indexOf('shopee') === -1 && url.indexOf('shp.ee') === -1) { 
        //   this.$notify(`vinted / caousell / shopee ${this.t('menu.only')}`)
        //   alert(`vinted / caousell / shopee ${this.t('menu.only')}`)
        else {
          let site 
          // if(site === 'CAROUSELL' || site === 'SHOPEE') this.showModal()
          // else {
          if(url.indexOf('vinted.') !== -1) {
            site = 'VINTED'
          } else {
            site = 'GET_URL_ITEM_INFO'
          }
          this.emitter.emit('dialog', {flag:true, title:'Loading'})
          url = this.api.shortenUrl(url)
          
          const param = {'type': site, 'url': url}

          await this.api.axiosGql(site, param) 
          .then( async (res) => { 
            if(res.data.error !== undefined) {
              this.emitter.emit('confirm', {message: `${this.t('sentence.item19')} ${this.t('sentence.item20')}`, header:`${this.t('menu.quote')}`, icon:'pi pi-info-circle'})
            } else if(res.status === 201 ) {
              // this.showModal()
              alert(`${this.t('sentence.item47')}`)
            } else {
              
              let imgUrl, wonPrice, name, fPrice, country, deliveryFee, unit
              
              if(site === 'GET_URL_ITEM_INFO') {
                if(res.data.data) {
                  const json = res.data.data.json
                  imgUrl = json.imgUrl || ""
                  fPrice = json.price || ""
                  name = json.name || ""
                  unit = json.currency || ""
                  country = json.country || ""
        
                  if(name) this.name = name
                  if(imgUrl) this.imgUrl = imgUrl
                  if(fPrice) this.sellPrice = fPrice
                  this.emitter.emit('dialog', {flag:true, title:'Loading'})
                  deliveryFee = '0'
                  await this.api.axiosGql('translate', {type:'translate', source:'en', target:'ko', keyword:country})
                  .then( async (res1) => {
                    if(res1.status === 200) {
                      country = res1.data
                    }
                  })
                  const countryCode = country + '환율'
                  if(country === "싱가포르") deliveryFee = '10'
                  if(country === '홍콩' ) deliveryFee = '100'

                  const param = {type: 'calcBuy', country: countryCode, sellPrice: fPrice, delivery: deliveryFee, etc: '0'}
                  await this.api.axiosGql('calcBuy', param) 
                  .then( async (res) => {
                    let won = String(res.data.result)
                    wonPrice = won
                    // document.getElementById("e_val1").innerHTML = won + this.t('unit.won')
                  }) 
                  .catch((error) => { 
                    console.log(error)
                  }) 
                  .finally(() => { 
                    this.emitter.emit('dialog', {flag:false, title:'Loading'})
                  })
                  if(!wonPrice) {
                    this.emitter.emit('confirm', {message: `${this.t('sentence.item21')}`, header:`${this.t('menu.quote')}`, icon:'pi pi-info-circle'})
                    return
                  }
                  this.url = url

                  this.country = country
                  this.wonPrice = wonPrice // TODO
                } else alert(`${this.t('sentence.item47')}\n${this.t('sentence.item48')}`)
              } else {
                imgUrl = res.data.imgUrl
                wonPrice = res.data.sellPrice
                name = res.data.name
                fPrice = res.data.pagePrice
                country = res.data.country
                deliveryFee = res.data.deliveryFee

                if(!wonPrice || wonPrice === undefined || wonPrice === null ) {
                  this.emitter.emit('confirm', {message: `${this.t('sentence.item21')}`, header:`${this.t('menu.quote')}`, icon:'pi pi-info-circle'})
                  return
                } else {
                  this.wonPrice = wonPrice
                  this.imgUrl = imgUrl
                  this.name = name
                  this.sellPrice = fPrice
                  this.country = country
                  this.url = res.data.url
  
                  unit = this.api.getCurrency(this.country)
                  
                }
              }
              console.log(this.wonPrice)
              console.log(this.name)
              console.log(this.country)
              console.log(Number(this.wonPrice).toLocaleString())
              console.log(isNaN(Number(this.wonPrice)))
              if( isNaN(Number(this.wonPrice)) || !this.wonPrice || !this.name || !this.country ) {
                this.emitter.emit('confirm', {message: `${this.t('sentence.item47')}\n${this.t('sentence.qna20')}`, header:`${this.t('menu.quote')}`, icon:'pi pi-info-circle'})
                return
              }
              
              this.$refs.table.style.display = '';
              this.$refs.result1.src = this.imgUrl;
              this.$refs.link.href = this.url;

              this.$refs.result2.innerHTML = `${this.t('menu.itemName')} : ` + this.name
              this.$refs.result3.innerHTML = `${ this.t('menu.fPrice') } : ` + this.sellPrice + unit
              this.$refs.result4.innerHTML = `${ this.t('menu.lPrice') } : ` + deliveryFee + unit + `${ deliveryFee === '0' ? ` (${this.t('menu.addLater')})` : ``}`
              this.$refs.result5.innerHTML = `${ this.t('menu.countryDepature') } : ` + this.country
              this.$refs.result6.innerHTML = `${ this.t('menu.buyAgentFee') } : ` + Number(this.wonPrice).toLocaleString() + `${this.t('unit.won')} <label style="color:red">(${this.t('menu.buyFeeInclude')}, ${this.t('menu.deliveryFeeExtra')})</label>`
            }
          }) 
          .catch((error) => { 
            console.log(error)
            this.emitter.emit('confirm', {message: `${this.t('sentence.item19')} ${this.t('sentence.item20')}`, header:`${this.t('menu.deliveryFeeExtra')}`, icon:'pi pi-info-circle'})
          }) 
          .finally(() => { 
            this.api.axiosGql('INSERT_STAT_KEYWORD', {type:'INSERT_STAT_KEYWORD', searchType:'0', keyword:url, opt:site, mail:this.api.getCookies('mail'), etc:this.imgUrl+','+this.name+','+this.sellPrice+','+this.country + ',' + this.wonPrice})
            this.emitter.emit('dialog', {flag:false, title:'Loading'})
          })
          // }
        }
      } else if(type === 4) {
        const country  = this.$refs.modalCountry.value
        const price = this.$refs.modalSellPrice.value

        if(price === '') alert(`${this.t('sentence.item22')}`)
        else if(country === '') alert(`${this.t('sentence.depatureCountryChoice')}`)
        else if(country === 'hk') {
          const param = {type: 'currency', country: '홍콩'}
          await this.api.axiosGql('currency', param) 
          .then(async (res) => { 
            const currency = res.data
            if(currency === undefined || currency === null || currency === 'null' || currency === '' ) {
              alert(`${this.t('sentence.retry')}`)
            } else {
              let wonPrice = (parseFloat(price) + 100) * parseFloat(currency)
              let fee = wonPrice * 0.1
              let sellPrice = 0
              if(fee < 8000) sellPrice = wonPrice + 8000
              else sellPrice = wonPrice + fee
              sellPrice = Math.ceil(sellPrice / 100) * 100
              alert(`${this.t('menu.estimatedBuyFee')} : ` + sellPrice.toLocaleString() + `${this.t('unit.won')}(${this.t('menu.buyFeeInclude')}, ${this.t('menu.deliveryFeeExtra')})`)
            }
          })
        } else if(country === 'sg') {
          const param = {type: 'currency', country: '싱가포르'}
          await this.api.axiosGql('currency', param) 
          .then(async (res) => { 
            const currency = res.data
            if(currency === undefined || currency === null || currency === 'null' || currency === '' ) {
              alert(`${this.t('sentence.retry')}`)
            } else {
              let wonPrice = (parseFloat(price) + 10) * parseFloat(currency)
              let fee = wonPrice * 0.1
              let sellPrice = 0
              if(fee < 8000) sellPrice = wonPrice + 8000
              else sellPrice = wonPrice + fee
              sellPrice = Math.ceil(sellPrice / 100) * 100
              alert(`${this.t('menu.estimatedBuyFee')} : ` + sellPrice.toLocaleString() + `${this.t('unit.won')}(${this.t('menu.buyFeeInclude')},(${this.t('menu.deliveryFeeExtra')})`)
            }
          })
        }
      }
    },
  }
}
</script>

<style scoped>
.table {
  width: 100%;
  margin-top: 10px;
}
.padding-left {
  padding-left:10px;
}
.td {
  width:100%; 
  text-align:right;
}
td {
  padding: 0px;
}
.padding {
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 10px;
}
#url {
  width: 100%;
}
#select {
  width: 100%;
  min-width: 100px;
  text-align: center;
}
input {
  width: auto;
}
</style>
